import fetch from "../fetch";

export default ({ saleId, propertyId }) =>
  fetch({
    method: "DELETE",
    path: `/re/sales/${saleId}/props/${propertyId}`
  });
